module.exports = __webpack_public_path__ + "img/right-info-open.18bab8b2.png";